import {Injectable} from '@angular/core';
import {HttpAuthService} from '@shared/service/http-auth.service';
import {Observable} from 'rxjs/Observable';
import {Utilities} from '@shared/utilities/utilities.model';
import {Headers, RequestOptions, Response} from '@angular/http';
import {AlertModel, AlertsList} from '../models/alert.model';
import {ThreadsList} from '../models/threads-list.model';
import {ThreadsFilter} from '../models/thread-filter.model';
import {ListService} from '@shared/models/list-service.model';
import {NCStatsFilter} from '../models/nc-stats-filter.model';
import {NCNewAlert} from '../models/nc-new-alert.model';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {NCReaderItem, NCReadersModel} from '../models/nc-readers.model';
import {NemoModuleKeys} from '@shared/models/user-permission.model';
import {
	AuthorityUsersPermissions,
	CONTRACT_CLOSING_ALD_PROFILES,
	CONTRACT_CLOSING_DK_BO_PROFILES,
	CONTRACT_CLOSING_DKC_PROFILES,
	CONTRACT_CLOSING_DKO_PROFILES,
	CONTRACT_CLOSING_SPO_PROFILES,
	MODULE_AUTHORITY_KEY,
	MODULE_CONTRACT_CLOSING_KEY,
	MODULE_DELIVERY_KEY,
	MODULE_TYRES_KEY, PROFILE_TYRE_CUSTOMER_SERVICE_KEY, PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY, PROFILE_TYRES_ADMIN_KEY, PROFILE_TYRES_ASSISTANCE_CENTER_KEY, PROFILE_TYRES_CENTER_SUPER_USER
} from '../../permissions-variables';
import {PermissionService} from '@shared/service/permission.service';
import {NotificationCenterUtilities} from '../utilities/notification-center.utilities';
import {ROOT_NOTIFICATION_CENTER} from 'app/app-routing-roots';
import {NC_ALERTS, NC_ALERTS_DETAILS, NC_ALERTS_NEW, NC_DASHBOARD} from '../notification-center-routing-roots';
import {Router} from '@angular/router';
import {throwError, timer} from 'rxjs';
import {catchError, map, switchMap, takeWhile, tap} from 'rxjs/operators';
import {ThreadItemList} from '../models/thread-item-list.model';

@Injectable()
export class ThreadService implements ListService {

	protected BASE_TIMER: number = 300000;
	private currentPreCompletedAlert: NCNewAlert;
	private environment: AppConfigEnvironment;

	private alertAlive: boolean;
	private unreadAlive: boolean;

	private readers: NCReaderItem[];
	private sender: NCReaderItem;
	private alertContext: string;
	private previousLocation: string;

	constructor(
		private httpAuthService: HttpAuthService,
		private userV3Service: UserV3Service,
		private selectCommoditiesService: SelectCommoditiesService,
		private appConfig: AppConfigEnvironmentService,
		private permissionService: PermissionService,
		public router: Router
	) {
		this.environment = appConfig.Environment;
	}


	setPreCompletedAlert(alert: NCNewAlert): void {
		this.currentPreCompletedAlert = alert;
	}

	getCurrentPreCompletedAlert(): NCNewAlert {
		const res: NCNewAlert = this.currentPreCompletedAlert;
		this.currentPreCompletedAlert = null;
		return res;
	}

	getAvailableReaders(): NCReaderItem[] {
		const readers: NCReaderItem[] = this.readers;
		this.readers = null;
		return readers;
	}

	setAvailableReaders(readers: NCReaderItem[]): void {
		this.readers = readers;
	}

	getSender(): NCReaderItem {
		const sender: NCReaderItem = this.sender;
		this.sender = null;
		return sender;
	}

	setSender(sender: NCReaderItem): void {
		this.sender = sender;
	}

	getContext(): string {
		return this.alertContext;
	}

	setContext(context: string): void {
		this.alertContext = context;
	}

	getPreviousLocation(): string {
		const location: string = this.previousLocation;
		this.previousLocation = null;
		return location;
	}

	setPreviousLocation(location: string): void {
		this.previousLocation = location;
	}

	/** List of threads **/
	getList(filter: ThreadsFilter): Observable<ThreadsList> {
		const readers: string[] = this.getReadersForUser().map(r => r.id);
		let url: string = this.environment.NOTIFICATION_CENTER + '/threads';
		const filters: ThreadsFilter = new ThreadsFilter({...(filter || {}), readers});
		if(filter.text){
			filter.text=filter.text.trim();
		}
		if (filter) {
			url = url + filters.getFilterUrl().replace(/\+/g, '%2B');
		}
		return new Observable<ThreadsList>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT /*this.notificationUtilities.setCommoditiesHeader()*/).subscribe(
					response => {
						if (response.status === 200) {
							try {
								observer.next(new ThreadsList(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}

	/** List of threads for dashboard **/
	getListForDashboard(module: string, page_size: number, page: number, commodities_ids?: string[]): Observable<ThreadsList> {
		let url: string = this.environment.NOTIFICATION_CENTER + '/threads';
		const readers: string[] = this.getReadersForUser().map(r => r.id);
		const filter: ThreadsFilter = new ThreadsFilter({readers});
		filter.module = module;
		filter.page_size = page_size;
		filter.page = page;

		if (!!commodities_ids) {
			filter.super_user_commodity_ids = commodities_ids;
		}

		url = url + filter.getFilterUrl().replace(/\+/g, '%2B');

		/*const options = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('user_id', this.userV3Service.getCurrentUser().id);*/


		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => new ThreadsList(response.json())),
			// tslint:disable-next-line
			catchError(err => throwError(err))
		);
	}

	getReadersForNewAlertFromModule(module: string): NCReaderItem[] {
		const readers: NCReaderItem[] = [];
		this.permissionService.getUserV3Permission().subscribe(
			userPermissions => {
				switch (module) {
					case MODULE_DELIVERY_KEY:
						readers.push(NCReadersModel.ALDOPERATOR_READER, NCReadersModel.DELIVERYSP_READER);
						break;
					case MODULE_CONTRACT_CLOSING_KEY:
						switch (true) {
							case userPermissions.hasProfile(CONTRACT_CLOSING_SPO_PROFILES):
								readers.push(NCReadersModel.ALDOPERATOR_READER, NCReadersModel.CCDEKRA_READER, NCReadersModel.CCDKO_READER, NCReadersModel.CCBACKOFFICE_READER);
								break;
							case userPermissions.hasProfile(CONTRACT_CLOSING_ALD_PROFILES):
								readers.push(NCReadersModel.CCSP_READER, NCReadersModel.CCDEKRA_READER, NCReadersModel.CCDKO_READER, NCReadersModel.CCBACKOFFICE_READER);
								break;
							case userPermissions.hasProfile(CONTRACT_CLOSING_DKO_PROFILES):
								readers.push(NCReadersModel.CCSP_READER, NCReadersModel.ALDOPERATOR_READER, NCReadersModel.CCDEKRA_READER, NCReadersModel.CCBACKOFFICE_READER);
								break;
							case userPermissions.hasProfile(CONTRACT_CLOSING_DKC_PROFILES):
								readers.push(NCReadersModel.CCSP_READER, NCReadersModel.ALDOPERATOR_READER, NCReadersModel.CCDKO_READER, NCReadersModel.CCBACKOFFICE_READER);
								break;
							case userPermissions.hasProfile(CONTRACT_CLOSING_DK_BO_PROFILES):
								readers.push(NCReadersModel.ALDOPERATOR_READER, NCReadersModel.CCDEKRA_READER, NCReadersModel.CCDKO_READER);
								break;
							default:
								break;
						}
						break;
					case MODULE_TYRES_KEY:
						readers.push(NCReadersModel.SERVICE_POINT, NCReadersModel.ALD_OPERATOR, NCReadersModel.POOL_OPERATOR, NCReadersModel.CUSTOMER_SERVICE_OPERATOR);
						break;
					case MODULE_AUTHORITY_KEY:
						if (userPermissions.isDealerOperator(NemoModuleKeys.AUTHORITY)) {
							readers.push(NCReadersModel.ALD_OPERATOR, NCReadersModel.SERVICE_POINT);
						} else {
							if (userPermissions.isAldOperator(NemoModuleKeys.AUTHORITY)) {
								if (!this.permissionService.hasPermissions(AuthorityUsersPermissions.authority_supervisor_dashboard)) {
									readers.push(NCReadersModel.SERVICE_POINT, NCReadersModel.ALD_SUPERVISOR);
								} else {
									readers.push(NCReadersModel.SERVICE_POINT, NCReadersModel.ALD_OPERATOR);
								}
							}
							if (userPermissions.isCenterOperator(NemoModuleKeys.AUTHORITY)) {
								readers.push(NCReadersModel.ALD_OPERATOR, NCReadersModel.DEALER);
							}
						}
						break;
				}
			});
		return readers;
	}

	getReadersForCurrentUserByModule(): NCReaderItem {

		let reader: NCReaderItem;
		const userPermission = this.permissionService.getCurrentUserPermissions();
		this.permissionService.getUserModules().forEach(
			module => {
				this.permissionService.getUserV3Permission().subscribe(
					userPermissions => {
						switch (module) {
							case MODULE_CONTRACT_CLOSING_KEY:  {
								switch (true) {
									case userPermissions.hasProfile(CONTRACT_CLOSING_SPO_PROFILES): {
										reader = NCReadersModel.CCSP_READER;
										break;
									}
									case userPermissions.hasProfile(CONTRACT_CLOSING_ALD_PROFILES): {
										reader = NCReadersModel.ALDOPERATOR_READER;
										break;
									}
									case userPermissions.hasProfile(CONTRACT_CLOSING_DKO_PROFILES): {
										reader = NCReadersModel.CCDKO_READER;
										break;
									}
									case userPermissions.hasProfile(CONTRACT_CLOSING_DKC_PROFILES): {
										reader = NCReadersModel.CCDEKRA_READER;
										break;
									}
									case userPermissions.hasProfile(CONTRACT_CLOSING_DK_BO_PROFILES): {
										reader = NCReadersModel.CCBACKOFFICE_READER;
										break;
									}
									default:
										break;
								}

								break;
							}
							case MODULE_TYRES_KEY: {
								switch (true) {
									case userPermissions.hasProfile([PROFILE_TYRES_ASSISTANCE_CENTER_KEY]): {
										reader = NCReadersModel.SERVICE_POINT;
										break;
									}
									case userPermissions.hasProfile([PROFILE_TYRES_ADMIN_KEY]): {
										reader = NCReadersModel.ALD_OPERATOR;
										break;
									}
									case userPermissions.hasProfile([PROFILE_TYRE_CUSTOMER_SERVICE_KEY]): {
										reader = NCReadersModel.CUSTOMER_SERVICE_OPERATOR;
										break;
									}
									case userPermissions.hasProfile([PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY]): {
										reader = NCReadersModel.POOL_OPERATOR;
										break;
									}
									default:
										break;
								}

								break;
							}
							case MODULE_AUTHORITY_KEY: {
								switch (true) {
									case userPermissions.isAldOperator(NemoModuleKeys.AUTHORITY): {
										reader = userPermissions.hasPermissions(AuthorityUsersPermissions.authority_supervisor_dashboard) ? NCReadersModel.ALD_SUPERVISOR : NCReadersModel.ALD_OPERATOR;
										break;
									}
									case userPermissions.isDealerOperator(NemoModuleKeys.AUTHORITY): {
										reader = NCReadersModel.DEALER;
										break;
									}
									case userPermissions.isCenterOperator(NemoModuleKeys.AUTHORITY): {
										reader = NCReadersModel.SERVICE_POINT;
										break;
									}
									default:
										break;
								}

								break;
							}
						}
					}
				);
			}
		);
		return reader;
	}

	getReadersForUser(): NCReaderItem[] {
		const readers: NCReaderItem[] = [];
		this.permissionService.getUserModules().forEach(
			module => {
				this.permissionService.getUserV3Permission().subscribe(
					userPermissions => {
						switch (module) {
							case MODULE_DELIVERY_KEY:
								readers.push(NCReadersModel.ALDOPERATOR_READER, NCReadersModel.DELIVERYSP_READER);
								break;
							case MODULE_CONTRACT_CLOSING_KEY:
								switch (true) {
									case userPermissions.hasProfile(CONTRACT_CLOSING_SPO_PROFILES):
										readers.push(NCReadersModel.CCSP_READER);
										break;
									case userPermissions.hasProfile(CONTRACT_CLOSING_ALD_PROFILES):
										readers.push(NCReadersModel.ALDOPERATOR_READER);
										break;
									case userPermissions.hasProfile(CONTRACT_CLOSING_DKO_PROFILES):
										readers.push(NCReadersModel.CCDKO_READER);
										break;
									case userPermissions.hasProfile(CONTRACT_CLOSING_DKC_PROFILES):
										readers.push(NCReadersModel.CCDEKRA_READER);
										break;
									case userPermissions.hasProfile(CONTRACT_CLOSING_DK_BO_PROFILES):
										readers.push(NCReadersModel.CCBACKOFFICE_READER);
										break;
									default:
										break;
								}
								break;
							case MODULE_TYRES_KEY:
								switch (true) { 
									case userPermissions.hasProfile([PROFILE_TYRES_ASSISTANCE_CENTER_KEY]):
										readers.push(NCReadersModel.SERVICE_POINT);
										break;
									case userPermissions.hasProfile([PROFILE_TYRES_ADMIN_KEY]):
										readers.push(NCReadersModel.ALD_OPERATOR);
										break;
									case userPermissions.hasProfile([PROFILE_TYRE_CUSTOMER_SERVICE_KEY]):
										readers.push(NCReadersModel.CUSTOMER_SERVICE_OPERATOR);
										break;
									case userPermissions.hasProfile([PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY]):
										readers.push(NCReadersModel.POOL_OPERATOR);
										break;
									default:
										break;
								}
								break;
							case MODULE_AUTHORITY_KEY:
								switch (true) {
									case userPermissions.isAldOperator(NemoModuleKeys.AUTHORITY):
										readers.push(
											userPermissions.hasPermissions(AuthorityUsersPermissions.authority_supervisor_dashboard) ? NCReadersModel.ALD_SUPERVISOR : NCReadersModel.ALD_OPERATOR
										);
										break;
									case userPermissions.isDealerOperator(NemoModuleKeys.AUTHORITY):
										readers.push(NCReadersModel.DEALER);
										break;
									case userPermissions.isCenterOperator(NemoModuleKeys.AUTHORITY):
										readers.push(NCReadersModel.SERVICE_POINT);
										break;
									default:
										break;
								}
								break;
						}
					}
				);
			}
		);
		return readers;
	}

	/** get list alert of thread **/
	getAlertsOfThread(threadID: string, filter?: ThreadsFilter): Observable<AlertsList> {
		let url: string = this.environment.NOTIFICATION_CENTER + '/threads/' + threadID + '/alerts';
		if (filter) {
			url = url + filter.getFilterUrl().replace(/\+/g, '%2B');
		}

		//const options = Utilities.getOptionsWithCommodities(this.selectCommoditiesService.getAldCommodityIds());
		/*const options = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('user_id', this.userV3Service.getCurrentUser().id);*/

		return new Observable<AlertsList>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
					response => {
						if (response.status === 200) {
							try {
								observer.next(new AlertsList(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}

	/** add alert to thread **/
	addAlertToThread(body: any, thread_id: string): Observable<Response> {
		const url: string = this.environment.NOTIFICATION_CENTER + /threads/ + thread_id + '/alerts';
		// const options: any = Utilities.setOptionsWithCenterID(this.selectCommoditiesService.getAldCommoditiesIds());
		// options.headers.set('user_id', this.userV3Service.getCurrentUser().id);
		return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT/*, options*/);
	}

	/** update tags flags ... of thread **/
	updateThread(thread_id: any, body: any): Observable<Response> {
		const url: string = this.environment.NOTIFICATION_CENTER + '/threads/' + thread_id;

		// const options = Utilities.getOptionsWithCommodities(this.selectCommoditiesService.getAldCommodityIds());
		const options: RequestOptions = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('Content-Type', 'application/json');
		options.headers.set('user_id', this.userV3Service.getCurrentUser().id);
		return this.httpAuthService.patch(url, body, this.environment.ROOT_REDIRECT, options);
	}

	updateThreads(threads_id: any, body: any): Observable<Response> {
		const url: string = this.environment.NOTIFICATION_CENTER + '/threads';

		// const options = Utilities.getOptionsWithCommodities(this.selectCommoditiesService.getAldCommodityIds());
		const options: RequestOptions = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('Content-Type', 'application/json');
		options.headers.set('thread-id', threads_id);
		return this.httpAuthService.patch(url, body, this.environment.ROOT_REDIRECT, options);
	}

	/** delete tag **/

	deleteTag(tag: string): Observable<Response> {
		const url: string = this.environment.NOTIFICATION_CENTER + '/tags/' + tag;
		return this.httpAuthService.delete(url, this.environment.ROOT_REDIRECT);
	}


	/** get stats of threads **/
	statsOfThreads(filter?: NCStatsFilter): Observable<any> {
		let url: string = this.environment.NOTIFICATION_CENTER + '/threads/stats';
		const readers: string[] = this.getReadersForUser().map(r => r.id);
		filter = new NCStatsFilter({...(filter || {}), readers});
		if (filter) {
			url = url + filter.getFilterUrl().replace(/\+/g, '%2B');
		}
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json()),
			// tslint:disable-next-line:no-unnecessary-callback-wrapper
			catchError(err => throwError(err))
		);
	}


	/**new alert => thread* **/
	newAlert(body: any): Observable<any> {
		const url: string = this.environment.NOTIFICATION_CENTER + '/alerts';
		const options: any = Utilities.setOptionsWithCenterID(this.selectCommoditiesService.getAldSupplierIds());
		options.headers.set('user_id', body.user_id);
		options.headers.set('Content-Type', 'application/json');
		// return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, null);

		return new Observable<any>(
			observer => {
				this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (response.status === 201) {
							try {
								observer.next(response.json());
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}

	/** get list alerts **/
	getAlerts(filter?: ThreadsFilter): Observable<Response> {
		const readers: string[] = this.getReadersForUser().map(r => r.id);
		let url: string = this.environment.NOTIFICATION_CENTER + '/alerts';
		filter = new ThreadsFilter({...(filter || {}), readers});
		if (filter) {
			url = url + filter.getFilterUrl().replace(/\+/g, '%2B');
		}
		// const options = Utilities.getOptionsWithCommodities(this.selectCommoditiesService.getAldCommodityIds());
		/*const options = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('user_id', this.userV3Service.getCurrentUser().id);*/
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT/*, options*/);
	}

	goToWriteNewAlert(module: string, id: any, plate: string, chassis: string, ald_commodity_id: string): void {
		const preCompleteAlert: NCNewAlert = new NCNewAlert();
		preCompleteAlert.ald_order_id = id;
		preCompleteAlert.ald_commodity_id = ald_commodity_id;
		preCompleteAlert.metadata.set(NotificationCenterUtilities.METADATA_CHASSIS, chassis);
		preCompleteAlert.metadata.set(NotificationCenterUtilities.METADATA_PLATE, plate);
		preCompleteAlert.module = module;
		preCompleteAlert.alert_id = Utilities.getUUID();
		this.setPreCompletedAlert(preCompleteAlert);
		this.router.navigate(['/' + ROOT_NOTIFICATION_CENTER + '/' + NC_DASHBOARD + '/' + NC_ALERTS + '/' + NC_ALERTS_NEW]);
	}

	generateNewAlert(module: string, ald_order_id: any, plate: string, chassis: string, ald_commodity_id?: string, commodity_id?: string[], isImportant?: boolean, metadata?: any): NCNewAlert {
		const alert: NCNewAlert = new NCNewAlert();
		alert.ald_order_id = ald_order_id;
		alert.ald_commodity_id = ald_commodity_id;
		alert.commodity_id = commodity_id;
		alert.metadata.set(NotificationCenterUtilities.METADATA_CHASSIS, chassis);
		alert.metadata.set(NotificationCenterUtilities.METADATA_PLATE, plate);
		alert.module = module;
		alert.alert_id = Utilities.getUUID();
		if (isImportant) {
			alert.flags = ['important'];
		}
		if (metadata) {
			Object.keys(metadata).forEach(attribute => alert.metadata.set(attribute, metadata[attribute]));
		}
		return alert;
	}

	navigateToNewAlertPage(): Promise<boolean> {
		return this.router.navigate(['/' + ROOT_NOTIFICATION_CENTER + '/' + NC_DASHBOARD + '/' + NC_ALERTS + '/' + NC_ALERTS_NEW]);
	}

	goToAlertDetails(id: string, module?: string): void {
		const filter: ThreadsFilter = new ThreadsFilter();
		filter.ald_order_id = id.toString();
		if (module) {
			filter.module = module;
		}
		this.getList(filter);
		const route: string = '/' + ROOT_NOTIFICATION_CENTER + '/' + NC_DASHBOARD + '/' + NC_ALERTS;
		this.router.navigate([route]);
	}

	onClickAlert(alert: AlertModel): void {
		if (alert.thread_id) {
			this.router.navigate([`/${ROOT_NOTIFICATION_CENTER}/${NC_DASHBOARD}/${NC_ALERTS}/${NC_ALERTS_DETAILS}/${alert.ald_order_id}/${alert.thread_id}`]);
		}
	}

	startAlertPolling(filter?: ThreadsFilter): Observable<Response> {
		this.alertAlive = true;
		return timer(0, this.BASE_TIMER).pipe(
			takeWhile(() => this.alertAlive),
			switchMap(() => this.getAlerts(filter))
		);
	}

	stopAlertPolling(): void {
		this.alertAlive = false;
	}

	startUnreadPolling(filter?: NCStatsFilter): Observable<any> {
		this.unreadAlive = true;
		return timer(0, this.BASE_TIMER).pipe(
			takeWhile(() => this.unreadAlive),
			switchMap(() => this.statsOfThreads(filter))
		);
	}

	stopUnreadPolling(): void {
		this.unreadAlive = false;
	}

	getThreadById(threadId: string): Observable<ThreadItemList> {
		return this.httpAuthService.get(`${this.environment.NOTIFICATION_CENTER}/threads/${threadId}`, this.environment.ROOT_REDIRECT)
			.pipe(
				tap(response => {
					if (!response.ok) {
						throw response;
					}
				}),
				map(response => response.json()),
				// tslint:disable-next-line:no-unnecessary-callback-wrapper
				catchError(err => throwError(err))
			);
	}

}
